<template>
  <div id="end-confirm">
    <ipub-model title=""
                width="400px"
                :visable="isVisable"
                :showHeader="false"
                style="text-align:center"
                @cancel="cancel"
                @confirm="confirm">
      <div class="content-center"
           style="">
        <ipub-icon type="iconDetails"
                   style="font-size:60px"
                   class="key-color"></ipub-icon>
        <div class="ipub-p2 content-center">
          The last invitation of the reviewer is less than {{publisherInfo.reviewLimitDay}} days. Are you sure you want to send the invitation?
        </div>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      hindex: ''
    }
  },
  computed: {
    ...mapGetters({
      publisherInfo: 'getPublisherInfo',
    })
  },
  methods: {
    async confirm () {
      this.$emit('confirm', this.inputData, this.inputData.__index)
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
.content-center {
  margin: 0 auto 20px;
  text-align: center;
}
</style>
